<nz-result nzStatus="success" [nzSubTitle]="subTituloTemplate" class="no-print resultado-protocolo">
</nz-result>

<ng-template #subTituloTemplate>
    <div class='protocolo-container'>{{protocolo.mensagem}}</div>
    <br>
    <div class="d-flex justify-content-center flex-column text-center titulo">
        <strong>Anote o protocolo:</strong>
        <b (click)="copy()" nz-popover nzPopoverTrigger="click" [nzPopoverContent]="popoverTemplate"
            [(nzPopoverVisible)]="popoverVisible">{{protocolo.protocolo}}</b>&nbsp;
    </div>
    <div class="d-flex justify-content-between mt-3">
        <div>
          <button nz-button type="buttom" nzType="default" [nzSize]="size" class="d-flex justify-align-center align-items-center rounded-2" (click)="fechar()">
            Continuar enviando
          </button>
        </div>
        <div>
          <button nz-button type="buttom" nzType="primary" [nzSize]="size" class="d-flex justify-align-center align-items-center rounded-2" (click)="ok()">
            Finalizar
          </button>
        </div>
    </div>
</ng-template>

<ng-template #popoverTemplate>
    <div class="d-flex align-items-center popover-content">
        Protocolo copiado para área de transferência &nbsp; <i nz-icon nzType="copy"></i>
    </div>
</ng-template>
